import ProductCreate from '_modules/product/views/ProductCreate.vue';
import ProductEdit from '_modules/product/views/ProductEdit.vue';
import ProductList from '_modules/product/views/ProductList.vue';
import Product from './Root.vue';

export default {
  path: 'produtos/',
  component: Product,
  name: 'admin-product',
  redirect: '/produtos/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-product-list',
      component: ProductList,
    },
    {
      path: 'novo/',
      name: 'admin-product-new',
      component: ProductCreate,
    },
    {
      path: ':productId/',
      name: 'admin-product-edit',
      component: ProductEdit,
    },
  ],
};
